import * as React from "react";
import { styled, css } from "styled-components";
import { Icon } from "components/common";
export const DRAG_HANDLE_DEFAULT_TITLE = "Drag or press space to reorder";
const Container = styled.button(
  ({ $isDragging, theme }) => css`
    margin-right: ${theme.spacings.xxs};
    cursor: ${$isDragging ? "grabbing" : "grab"};
    background: transparent;
    border: 0;
    padding: 0;
  `
);
const DragHandle = ({ itemTitle = void 0, dragHandleProps, isDragging, index }, ref) => {
  const dragHandleTitle = typeof itemTitle === "string" ? `${DRAG_HANDLE_DEFAULT_TITLE} ${itemTitle.toLocaleLowerCase()}` : `${DRAG_HANDLE_DEFAULT_TITLE}`;
  return /* @__PURE__ */ React.createElement(
    Container,
    {
      ...dragHandleProps,
      ref,
      $isDragging: isDragging,
      title: dragHandleTitle,
      "aria-label": dragHandleTitle,
      "data-sortable-index": index
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "drag_indicator" })
  );
};
export default React.forwardRef(DragHandle);
